import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import classnames from 'classnames';
import FacebookIcon from 'dibs-icons/exports/Facebook';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

// styles
import styles from './PdpSharedIconBubbles.scss';

// helpers
import { trackFacebookClick } from '../tracking/iconBubblesTracking';
import { facebookShare } from 'dibs-social-sharing/exports/shareActions';

const messages = defineMessages({
    label: {
        id: 'PdpSharedIconBubbleFacebook.label',
        defaultMessage: 'Share {title} on Facebook',
    },
});

function onClick({ item }) {
    trackFacebookClick(item.title);
    facebookShare({ newBrowserWindow: true });
}

function PdpSharedIconBubbleFacebookComponent(props) {
    const intl = useIntl();

    const className = classnames(
        props.label ? styles.bubbleWithLabel : styles.bubble,
        styles.facebook
    );

    return (
        <Link
            ariaLabel={intl.formatMessage(messages.label, { title: props.item?.title })}
            className={className}
            onClick={() => onClick(props)}
            role="menuitem"
            dataTn="pdp-shared-icon-facebook"
        >
            <FacebookIcon className={styles.icon} />
            {props.label && <span>{props.label}</span>}
        </Link>
    );
}

PdpSharedIconBubbleFacebookComponent.propTypes = {
    item: PropTypes.object.isRequired,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export const PdpSharedIconBubbleFacebook = createFragmentContainer(
    PdpSharedIconBubbleFacebookComponent,
    {
        item: graphql`
            fragment PdpSharedIconBubbleFacebook_item on Item {
                title
            }
        `,
    }
);
